import {ITimeData} from '~/shared/types/types';

export const scheduleDefaults: ITimeData[] = [];

export const templateSchedule = [
  {day: 2, from: {hour: 0, minute: 0}, to: {hour: 23, minute: 45}},
  {day: 3, from: {hour: 0, minute: 0}, to: {hour: 23, minute: 45}},
  {day: 4, from: {hour: 0, minute: 0}, to: {hour: 23, minute: 45}},
  {day: 5, from: {hour: 0, minute: 0}, to: {hour: 23, minute: 45}},
  {day: 6, from: {hour: 0, minute: 0}, to: {hour: 23, minute: 45}},
  {day: 7, from: {hour: 0, minute: 0}, to: {hour: 23, minute: 45}},
  {day: 8, from: {hour: 0, minute: 0}, to: {hour: 23, minute: 45}},
];
